import { NavigationGuard } from 'vue-router';
import { RouteNames } from '@/routes';

import { Cache } from '@/common/cache';
import { SDK } from '@/common/sdk';

export const facilityGuard: NavigationGuard = async (to, from, next) => {
    try {
        const facilityId = to.params.facilityId;
        if (!facilityId) {
            return next('/');
        }

        // Check cache for facility
        let facility = Cache.instance.facilities.value.find((item) => item.facilityId === facilityId);
        if (!facility) {
            try {
                const response = await SDK.instance.endpoints.Facilities.get(facilityId);
                facility = response.data;
            } catch (error: any) {
                if (error.isAxiosError && error.response?.status === 404) {
                    // Navigate to 404 keeping previous path
                    return next({ replace: true, name: RouteNames.notFound, params: { 0: to.path } });
                }
                throw error;
            }
        }

        if (!facility) {
            return next('/');
        }

        Cache.instance.facility.next(facility);
        return next();
    } catch (error: any) {
        console.log(error.response);
        return next({ replace: true, name: RouteNames.error, params: { title: 'Navigation error', error, to: to.fullPath } });
    }
};

export const facilityAndAdminGuard: NavigationGuard = async (to, from, next) => {

    try {

        const isAdmin = Cache.instance.isAdmin.value;
        if (!isAdmin) {
            return next({ name: RouteNames.facilities });
        }

    } catch (error: any) {
        return next({ replace: true, name: RouteNames.error, params: { title: 'Navigation error', error, to: to.fullPath } });
    }

    try {
        const facilityId = to.params.facilityId;
        if (!facilityId) {
            return next('/');
        }

        // Check cache for facility
        let facility = Cache.instance.facilities.value.find((item) => item.facilityId === facilityId);
        if (!facility) {
            try {
                const response = await SDK.instance.endpoints.Facilities.get(facilityId);
                facility = response.data;
            } catch (error: any) {
                if (error.isAxiosError && error.response?.status === 404) {
                    // Navigate to 404 keeping previous path
                    return next({ replace: true, name: RouteNames.notFound, params: { 0: to.path } });
                }
                throw error;
            }
        }

        if (!facility) {
            return next('/');
        }

        Cache.instance.facility.next(facility);
        return next();
    } catch (error: any) {
        console.log(error.response);
        return next({ replace: true, name: RouteNames.error, params: { title: 'Navigation error', error, to: to.fullPath } });
    }
};